/* Tysk katalog for locale-advisor-reports-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'adv.cf.cashBasisMissing': 'Die Kassengrundlage ist nicht verfügbar. Salden und Bewegungen müssen mit dem Hauptbuch abgestimmt werden können.',
  'adv.cf.cashBalanceEvidence': 'Der gebuchte Kassen- und Banksaldo beträgt {amount}. Dies ist kein von der Bank bestätigter Saldo.',
  'adv.rpt.period.profit': 'Im {quarter}. Quartal {year} betragen die Erlöse {income} und der Gewinn {result}.',
  'adv.rpt.period.loss': 'Im {quarter}. Quartal {year} betragen die Erlöse {income} und der Verlust {result}.',
  'adv.rpt.period.nativeSuppliers': 'Die Lieferantenliste umfasst datierte Einkäufe im Quartal, ohne Anlagegüter und importierte Jahreszusammenfassungen ohne Quartalsaufteilung.',
  'adv.rpt.period.choose': 'Zeitraum',
  'adv.rpt.period.year': 'Ganzes Jahr',
  'adv.rpt.period.yearLabel': 'Ganzes Jahr {year}',
  'adv.rpt.period.quarter': '{quarter}. Quartal',
  'adv.rpt.period.label': '{quarter}. Quartal {year}',
  'adv.rpt.period.vsQuarter': 'gegenüber dem gleichen Quartal im Vorjahr',
  'adv.rpt.period.quarterBasis': 'Buchhaltungszahlen für {from}–{to}. Die Bilanz zeigt den Saldo zum Periodenende.',
  'adv.rpt.period.currentStatus': 'Nachverfolgungsstatus bei Berichtserstellung am {date}. Dieser Teil verwendet die aktuellen offenen Posten und die Jahresübersicht, nicht den historischen Status zum Quartalsende.',
  'adv.rpt.period.rolling': 'Rollierende 12 Monate bis {to}, verglichen mit den vorangegangenen 12 Monaten.',
  'adv.rpt.period.nativeSales': 'Kunden- und Rechnungsdetails umfassen gebuchte Rechnungen mit Datum im Quartal. Importierte Jahreszusammenfassungen ohne Quartalsaufteilung sind hier nicht enthalten.',
  'adv.rpt.period.budget': 'Die Buchungen im gewählten Quartal werden mit dem Budget für dieselben drei Monate verglichen.',
  'adv.rpt.period.pdfUnavailable': 'Das neue PDF-Layout ist auf dem Server noch nicht verfügbar. Versuche es nach dem Update erneut.',
  'adv.rpt.slides.present': 'Präsentieren',
  'adv.rpt.slides.exit': 'Präsentation beenden',
  'adv.rpt.slides.readable': 'Seitentext lesen',
  'adv.rpt.slides.previous': 'Zurück',
  'adv.rpt.slides.next': 'Weiter',
  'adv.rpt.slides.page': 'Seite {current} von {total}',
  'adv.rpt.modal.title': 'Bericht erstellen',
  'adv.rpt.modal.intro': 'Wähle eine Berichtsvorlage. SuperPlumma holt die Zahlen aus deiner Buchhaltung und stellt einen Entwurf zusammen, den du vor dem Teilen prüfen kannst.',
  'adv.rpt.modal.generate': 'Bericht erstellen',
  'adv.rpt.modal.cancel': 'Abbrechen',
  'adv.rpt.modal.basis': 'Datengrundlage: {sources}',
  'adv.rpt.modal.year': 'Geschäftsjahr',
  'adv.rpt.modal.saved': 'Gespeicherte Berichte',
  'adv.rpt.modal.savedEmpty': 'Du hast noch keine gespeicherten Berichte.',
  'adv.rpt.modal.open': 'Öffnen',
  'adv.rpt.modal.delete': 'Löschen',
  'adv.rpt.modal.deleted': 'Der Bericht wurde gelöscht.',
  'adv.rpt.hero.cta': 'Bericht erstellen',
  'adv.rpt.saved.title': 'Gespeicherte Berichte',
  'adv.rpt.saved.tab': 'Gespeicherte Berichte',
  'adv.rpt.saved.description': 'Gespeicherte Berichte bleiben als Momentaufnahmen erhalten und ändern sich nicht, wenn die Buchhaltung aktualisiert wird.',
  'adv.rpt.saved.count': '{count} von {limit} Berichten gespeichert',
  'adv.rpt.saved.limitError': 'Du kannst maximal {limit} Berichte speichern. Lösche einen Bericht, bevor du einen neuen speicherst.',
  'adv.rpt.saved.loading': 'Gespeicherte Berichte werden geladen …',
  'adv.rpt.saved.emptyTitle': 'Keine gespeicherten Berichte',
  'adv.rpt.saved.emptyText': 'Erstelle einen Bericht und speichere ihn, wenn du genau diese Version behalten möchtest.',
  'adv.rpt.saved.loadFailed': 'Gespeicherte Berichte konnten nicht geladen werden.',
  'adv.rpt.saved.deleteFailed': 'Der Bericht konnte nicht gelöscht werden.',
  'adv.rpt.tpl.styre.name': 'Vorstands- und Managementbericht',
  'adv.rpt.tpl.styre.desc': 'Umfassender Bericht für den Vorstand mit Ergebnis, Liquidität, Risiken und empfohlenen Maßnahmen.',
  'adv.rpt.tpl.manedsrapport.name': 'Monatsbericht',
  'adv.rpt.tpl.manedsrapport.desc': 'Status für den gewählten Monat mit Budget, Vorjahresvergleich, Trend und empfohlenen nächsten Schritten.',
  'adv.rpt.tpl.likviditet.name': 'Liquiditätsbericht',
  'adv.rpt.tpl.likviditet.desc': 'Offene Posten, Puffer und laufender Saldo auf Basis gebuchter Zahlen.',
  'adv.rpt.tpl.avvik.name': 'Ergebnis- und Abweichungsbericht',
  'adv.rpt.tpl.avvik.desc': 'Die größten Abweichungen vom Budget seit Jahresbeginn und die Kostenpositionen, die sich am stärksten verändert haben.',
  'adv.rpt.tpl.kunde.name': 'Kunden- und Umsatzbericht',
  'adv.rpt.tpl.kunde.desc': 'Umsatzentwicklung, größte Kunden, Kundenkonzentration und Außenstände.',
  'adv.rpt.tpl.kostnad.name': 'Kostenbericht',
  'adv.rpt.tpl.kostnad.desc': 'Kostenentwicklung, die größten Lieferanten und Belege ohne Dokumentation.',
  'adv.rpt.tpl.utestaende.name': 'Offene Posten',
  'adv.rpt.tpl.utestaende.desc': 'Unbezahlte Kunden- und Lieferantenposten, aufgeteilt nach überfällig und nicht fällig.',
  'adv.rpt.tpl.arsoppsummering.name': 'Jahreszusammenfassung',
  'adv.rpt.tpl.arsoppsummering.desc': 'Fasst das ganze Jahr zusammen — Ergebnis, Bilanz, Umsatz, Kosten und Risiken.',
  'adv.rpt.length.2to3': '2–3 Seiten',
  'adv.rpt.length.2to4': '2–4 Seiten',
  'adv.rpt.length.3to5': '3–5 Seiten',
  'adv.rpt.length.4to6': '4–6 Seiten',
  'adv.rpt.length.8to12': '8–12 Seiten',
  'adv.rpt.length.variable': 'Umfang richtet sich nach der Datengrundlage',
  'adv.rpt.length.10to14': '10–14 Seiten',
  'adv.rpt.doc.contents': 'Inhalt',
  'adv.rpt.doc.brand': 'PLUMME / AI BERATER',
  'adv.rpt.doc.continued': 'Forts.',
  'adv.rpt.doc.back': 'Zurück',
  'adv.rpt.doc.draft': 'Entwurf',
  'adv.rpt.doc.saved': 'Gespeichert',
  'adv.rpt.doc.save': 'Speichern',
  'adv.rpt.doc.savedToast': 'Der Bericht wurde gespeichert.',
  'adv.rpt.doc.exportPdf': 'PDF exportieren',
  'adv.rpt.doc.exportPptx': 'PowerPoint herunterladen',
  'adv.rpt.doc.exportingPptx': 'PowerPoint wird erstellt …',
  'adv.rpt.doc.exportPptxFailed': 'Die PowerPoint-Datei konnte nicht erstellt werden. Versuche es erneut.',
  'adv.rpt.doc.presentation': 'PRÄSENTATION',
  'adv.rpt.doc.coverFoot': 'Aus der Berichtsgrundlage in Plumme erstellt',
  'adv.rpt.doc.exporting': 'PDF wird erstellt …',
  'adv.rpt.doc.exportFailed': 'Die Berichtsdatei konnte nicht erstellt werden. Versuche es erneut.',
  'adv.rpt.doc.period': '{year} · {months} Monate des Jahres',
  'adv.rpt.doc.createTask': 'Aufgabe erstellen',
  'adv.rpt.doc.taskCreated': 'Im Aktionscenter mit Nachverfolgung am {date} hinzugefügt.',
  'adv.rpt.doc.taskFailed': 'Die Aufgabe konnte nicht erstellt werden.',
  'adv.rpt.doc.taskNote': 'Erstellt aus {report}.',
  'adv.rpt.narr.section': 'Zusammenfassung von SuperPlumma',
  'adv.rpt.narr.tag': 'Geschrieben von SuperPlumma',
  'adv.rpt.narr.idle': 'Lass SuperPlumma den Bericht lesen und die Zusammenfassung schreiben: worum es geht, was sich tatsächlich bewegt hat und was du jetzt tun solltest.',
  'adv.rpt.narr.write': 'Zusammenfassung schreiben',
  'adv.rpt.narr.rewrite': 'Neu schreiben',
  'adv.rpt.narr.loading': 'SuperPlumma liest den Bericht …',
  'adv.rpt.narr.failed': 'Die Zusammenfassung konnte nicht geschrieben werden. Die Zahlen im Bericht sind trotzdem vollständig.',
  'adv.rpt.narr.drivers': 'Das hat sich bewegt',
  'adv.rpt.narr.watch': 'Das solltest du im Blick behalten',
  'adv.rpt.narr.nextStep': 'Nächster Schritt: ',
  'adv.rpt.narr.foot': 'Die Zusammenfassung basiert auf den Zahlen im Bericht. Alle Beträge werden mit dem Bericht abgeglichen, bevor der Text angezeigt wird.',
  'adv.rpt.sec.changeSince': 'Änderungen seit dem letzten Bericht',
  'adv.rpt.col.lastReport': 'Letzter Bericht',
  'adv.rpt.col.now': 'Jetzt',
  'adv.rpt.col.change': 'Veränderung',
  'adv.rpt.note.changeSinceBasis': 'Verglichen mit dem Bericht, der am {date} gespeichert wurde. Dessen Zahlen sind eine Momentaufnahme und ändern sich nachträglich nicht.',
  'adv.rpt.empty.noPreviousReport': 'Dies ist der erste gespeicherte Bericht dieser Art für das Jahr. Beim nächsten Mal zeigt dieser Abschnitt, was sich seitdem geändert hat.',
  'adv.rpt.empty.noComparableReport': 'Der letzte Bericht enthält keine Kennzahlen zum Vergleich.',
  'adv.rpt.sec.summary': 'Zusammenfassung',
  'adv.rpt.sec.events': 'Wesentliche Ereignisse',
  'adv.rpt.sec.keyFigures': 'Wirtschaftliche Kennzahlen',
  'adv.rpt.sec.budget': 'Ergebnis im Vergleich zum Budget',
  'adv.rpt.sec.liquidity': 'Liquidität und Zahlungsverpflichtungen',
  'adv.rpt.sec.forecast': 'Laufender Saldo über das Jahr',
  'adv.rpt.sec.balance': 'Bilanz und Solidität',
  'adv.rpt.sec.resultTrend': 'Ergebnisentwicklung',
  'adv.rpt.sec.sales': 'Umsatz- und Kundenentwicklung',
  'adv.rpt.sec.customerChange': 'Kundentreue und Zahlungsdauer',
  'adv.rpt.sec.costTrend': 'Kostenentwicklung',
  'adv.rpt.sec.suppliers': 'Größte Lieferanten',
  'adv.rpt.sec.voucherReview': 'Zu prüfende Belege',
  'adv.rpt.sec.receivables': 'Kundenposten',
  'adv.rpt.sec.payables': 'Lieferantenposten',
  'adv.rpt.sec.risk': 'Risiken und Unsicherheiten',
  'adv.rpt.sec.actions': 'Empfohlene Maßnahmen',
  'adv.rpt.sec.decisions': 'Entscheidungsvorlagen',
  'adv.rpt.sec.dataBasis': 'Datengrundlage',
  'adv.rpt.sec.bridge': 'Was das Ergebnis bewegt hat',
  'adv.rpt.sec.workingCapital': 'Working Capital und Kapitalbindungsdauer',
  'adv.rpt.sec.rolling': 'Rollierende 12 Monate',
  'adv.rpt.col.driver': 'Treiber',
  'adv.rpt.col.effect': 'Effekt',
  'adv.rpt.col.priority': 'Priorität',
  'adv.rpt.bridge.opening': 'Ergebnis {year}',
  'adv.rpt.bridge.closing': 'Ergebnis {year}',
  'adv.rpt.bridge.revenue': 'Veränderung der Erlöse',
  'adv.rpt.bridge.finance': 'Veränderung des Finanzergebnisses',
  'adv.rpt.bridge.other': 'Übrige Posten ({count} Zeilen)',
  'adv.rpt.bridge.readGuide': 'Von links lesen: Beginne mit dem Vorjahresergebnis. Grün hebt das Ergebnis, Rot senkt es. Der letzte Balken ist das Ergebnis dieses Jahres. Die Beträge darunter zeigen jeden Beitrag.',
  'adv.rpt.bridge.readShort': 'Vom Vorjahr bis heute · Grün hebt das Ergebnis · Rot senkt es',
  'adv.rpt.note.bridgeBasis': 'Zeilen mit einer Wirkung unter {amount} sind zusammengefasst. Die Brücke führt vom Ergebnis {year} zum Ergebnis dieses Jahres, und die Summe der Treiber ergibt die gesamte Veränderung.',
  'adv.rpt.empty.noBridgeBasis': 'Ohne gebuchte Zahlen für {year} kann die Veränderung nicht nach Treibern aufgeschlüsselt werden.',
  'adv.rpt.empty.noBridgeChange': 'Das Ergebnis ist gegenüber {year} unverändert.',
  'adv.rpt.metric.receivableDays': 'Forderungen aus Lieferungen',
  'adv.rpt.metric.payableDays': 'Lieferantenverbindlichkeiten',
  'adv.rpt.metric.capitalGap': 'Netto-Bindungsdauer',
  'adv.rpt.metric.measuredPaymentDays': 'Tatsächliche Zahlungsdauer',
  'adv.rpt.metric.netCapitalTied': 'Netto gebundenes Kapital',
  'adv.rpt.note.capitalGapPositive': 'Du wartest {days} Tage länger auf dein Geld, als du selbst zum Bezahlen brauchst. In diesem Zeitraum muss der Betrieb aus eigener Kasse finanziert werden.',
  'adv.rpt.note.capitalGapNegative': 'Du zahlst später, als du bezahlt wirst. Lieferantenkredite finanzieren dann einen Teil des Betriebs.',
  'adv.rpt.note.capitalGapUnknown': 'Die Netto-Bindungsdauer kann nicht berechnet werden, weil die Umsatz- oder Kostengrundlage fehlt.',
  'adv.rpt.note.workingCapitalBasis': 'Forderungs- und Lieferantentage sind Schätzungen auf Basis offener Posten und {months} Monaten des Berichtsjahres. Die tatsächliche Zahlungsdauer wird nur anhand bezahlter Kundenrechnungen gemessen und ist daher keine identische Berechnung.',
  'adv.rpt.empty.noWorkingCapital': 'Keine offenen Kunden- oder Lieferantenposten, an denen sich die Bindungsdauer messen lässt.',
  'adv.rpt.cell.vsPrevious12': 'ggü. vorherigen 12',
  'adv.rpt.note.rollingBasis': 'Das Fenster umfasst die letzten {months} gebuchten Monate, sodass der Vergleich über den Jahreswechsel geht und nicht von Saisonalität beeinflusst wird.',
  'adv.rpt.note.noRollingComparison': 'Es gibt nicht genug Historie für einen Vergleich mit den vorangegangenen 12 Monaten.',
  'adv.rpt.empty.noRollingBasis': 'Zu wenig gebuchte Historie für ein rollierendes 12-Monats-Fenster.',
  'adv.rpt.certainty.planned': 'Geplant',
  'adv.rpt.summary.profit': 'Nach {months} Monaten {year} sind {income} Erträge und ein Gewinn von {result} gebucht.',
  'adv.rpt.summary.loss': 'Nach {months} Monaten {year} sind {income} Erträge und ein Verlust von {result} gebucht.',
  'adv.rpt.summary.margin': 'Das ergibt eine Umsatzrendite von {margin} %.',
  'adv.rpt.kpi.income': 'Erträge',
  'adv.rpt.kpi.costs': 'Kosten',
  'adv.rpt.kpi.result': 'Ergebnis',
  'adv.rpt.kpi.margin': 'Umsatzrendite',
  'adv.rpt.kpi.revenue': 'Fakturierter Umsatz',
  'adv.rpt.kpi.invoiceCount': 'Anzahl Rechnungen',
  'adv.rpt.kpi.avgInvoice': 'Durchschnitt pro Rechnung',
  'adv.rpt.kpi.customerCount': 'Anzahl Kunden',
  'adv.rpt.metric.receivables': 'Offen bei Kunden',
  'adv.rpt.metric.payables': 'Geschuldet an Lieferanten',
  'adv.rpt.metric.buffer': 'Liquiditätspuffer',
  'adv.rpt.metric.lowestBalance': 'Niedrigster Saldo im Jahr',
  'adv.rpt.metric.assets': 'Summe Vermögenswerte',
  'adv.rpt.metric.equityAndDebt': 'Summe Eigenkapital und Verbindlichkeiten',
  'adv.rpt.metric.solidity': 'Eigenkapitalquote',
  'adv.rpt.metric.repeatRate': 'Anteil Stammkunden',
  'adv.rpt.metric.avgPaymentDays': 'Durchschn. Zahlungsdauer',
  'adv.rpt.unit.days': '{days} Tage',
  'adv.rpt.col.line': 'Zeile',
  'adv.rpt.col.account': 'Konto',
  'adv.rpt.col.budgetToDate': 'Budget bisher',
  'adv.rpt.col.actual': 'Gebucht',
  'adv.rpt.col.variance': 'Abweichung',
  'adv.rpt.col.month': 'Monat',
  'adv.rpt.col.in': 'Ein',
  'adv.rpt.col.out': 'Aus',
  'adv.rpt.col.balance': 'Saldo',
  'adv.rpt.col.certainty': 'Grundlage',
  'adv.rpt.col.income': 'Erträge',
  'adv.rpt.col.costs': 'Kosten',
  'adv.rpt.col.result': 'Ergebnis',
  'adv.rpt.col.share': 'Anteil',
  'adv.rpt.chart.budgetActual': 'Budget gegenüber gebucht bisher',
  'adv.rpt.chart.monthlyResult': 'Ergebnis pro Monat',
  'adv.rpt.chart.incomeCosts': 'Erträge und Kosten pro Monat',
  'adv.rpt.chart.summaryResult': 'Von den Erträgen zum Ergebnis',
  'adv.rpt.chart.keyFiguresComparison': 'Kennzahlen gegenüber Vorjahr',
  'adv.rpt.chart.previousPeriod': 'Vorperiode',
  'adv.rpt.chart.currentPeriod': 'Aktuelle Periode',
  'adv.rpt.chart.cumulativeResult': 'Kumuliertes Ergebnis im Jahresverlauf',
  'adv.rpt.chart.runningBalance': 'Laufender Saldo und Liquiditätspuffer',
  'adv.rpt.chart.openItemsDue': 'Offene Posten nach Fälligkeit',
  'adv.rpt.chart.workingCapitalGap': 'In offenen Posten gebundenes Kapital',
  'adv.rpt.chart.balanceBasis': 'Gebuchte Bilanzgruppen',
  'adv.rpt.chart.bookedBalance': 'Gebuchter Saldo',
  'adv.rpt.chart.capitalStructure': 'Kapitalstruktur',
  'adv.rpt.chart.equityShare': 'Eigenkapital',
  'adv.rpt.chart.otherFinancing': 'Sonstige Finanzierung',
  'adv.rpt.chart.profit': 'Gewinn',
  'adv.rpt.chart.loss': 'Verlust',
  'adv.rpt.col.amount': 'Betrag',
  'adv.rpt.col.changeYoy': 'Veränderung ggü. Vorjahr',
  'adv.rpt.col.status': 'Status',
  'adv.rpt.row.income': 'Erträge',
  'adv.rpt.row.costs': 'Kosten',
  'adv.rpt.row.notDue': 'Nicht fällig',
  'adv.rpt.row.current': 'Nicht fällig',
  'adv.rpt.row.overdue': 'Überfällig',
  'adv.rpt.row.total': 'Summe',
  'adv.rpt.cell.vsPreviousYear': 'ggü. Vorjahr',
  'adv.rpt.cell.noBasis': 'Kein Vergleich',
  'adv.rpt.month.jan': 'Januar',
  'adv.rpt.month.feb': 'Februar',
  'adv.rpt.month.mar': 'März',
  'adv.rpt.month.apr': 'April',
  'adv.rpt.month.may': 'Mai',
  'adv.rpt.month.jun': 'Juni',
  'adv.rpt.month.jul': 'Juli',
  'adv.rpt.month.aug': 'August',
  'adv.rpt.month.sep': 'September',
  'adv.rpt.month.oct': 'Oktober',
  'adv.rpt.month.nov': 'November',
  'adv.rpt.month.dec': 'Dezember',
  'adv.rpt.certainty.confirmed': 'Gebucht',
  'adv.rpt.certainty.expected': 'Laufender Monat',
  'adv.rpt.certainty.uncertain': 'Noch nicht gebucht',
  'adv.rpt.budget.intro': 'Die gebuchten Zahlen für {months} Monate {year} werden mit dem Budget für dieselben Monate verglichen, nicht mit dem Budget des ganzen Jahres.',
  'adv.rpt.vouchers.missing': 'Bei {count} gebuchten Einkäufen fehlt der Beleg. Insgesamt betrifft das {net} Bemessungsgrundlage und {vat} abgezogene Vorsteuer.',
  'adv.rpt.action.impact': '{label}: {value}',
  'adv.rpt.priority.high': 'Hoch',
  'adv.rpt.priority.medium': 'Mittel',
  'adv.rpt.priority.low': 'Niedrig',
  'adv.rpt.severity.critical': 'Kritisch',
  'adv.rpt.severity.watch': 'Sollte nachverfolgt werden',
  'adv.rpt.severity.info': 'Zur Information',
  'adv.rpt.decision.risk': 'Entscheiden: {name}',
  'adv.rpt.decision.opportunity': 'Prüfen: {name}',
  'adv.rpt.decision.freeCapital': 'Entscheide über die Verwendung von freiem Kapital in Höhe von {amount}.',
  'adv.rpt.note.noPreviousYear': 'Es gibt keine gebuchten Zahlen für {year}, daher kann die Veränderung gegenüber dem Vorjahr nicht berechnet werden.',
  'adv.rpt.note.partialYear': 'Die Periode ist nicht abgeschlossen. Die Zahlen umfassen {months} Monate {year}.',
  'adv.rpt.note.noMaterialVariance': 'Keine einzelne Zeile weicht wesentlich vom Budget ab.',
  'adv.rpt.note.unbudgeted': '{count} Konten haben gebuchte Beträge ohne Budgetzeile. Sie sind in der Summe enthalten.',
  'adv.rpt.note.belowBuffer': 'Der niedrigste berechnete Saldo beträgt {lowest} und liegt unter dem gewählten Pufferziel von {buffer}.',
  'adv.rpt.note.aboveBuffer': 'Der laufende Saldo bleibt während der gesamten Periode über dem Puffer von {buffer}.',
  'adv.rpt.note.forecastIsBooked': 'Die Kurve ist ein laufender Saldo gebuchter Zahlen, kein Prognosemodell. Monate ohne Buchungen bleiben flach.',
  'adv.rpt.note.balanceGrouping': 'Eigenkapital und Verbindlichkeiten werden zusammen angezeigt, so wie die Summen- und Saldenliste sie gruppiert.',
  'adv.rpt.note.balanceInterimBasis': 'Die Bilanzgruppen werden so angezeigt, wie sie zum Berichtsdatum gebucht sind. Die Differenz zwischen den Seiten kann das Periodenergebnis enthalten und ist nicht als fertige Jahresbilanz zu lesen.',
  'adv.rpt.note.noCustomerSplit': 'Der Umsatz ist in der Grundlage nicht nach Kunden aufgeteilt.',
  'adv.rpt.note.concentration': '{name} macht {pct} % des fakturierten Umsatzes aus.',
  'adv.rpt.note.customerBasis': 'Die Zahlungsdauer wird anhand tatsächlich bezahlter Rechnungen gemessen.',
  'adv.rpt.note.costJump': 'Eine oder mehrere Kostenzeilen sind gegenüber dem Vorjahr um mehr als 25 % gestiegen.',
  'adv.rpt.note.topFiveOnly': 'Zeigt die fünf größten. Der Rest ist in den Summen enthalten, aber nicht aufgeführt.',
  'adv.rpt.note.vouchersComplete': 'Alle gebuchten Einkäufe haben einen Beleg.',
  'adv.rpt.note.vouchersRequired': 'Das bokføringsloven verlangt eine Dokumentation für jede Buchung. Fehlende Belege sollten beschafft werden, bevor die Periode gemeldet wird.',
  'adv.rpt.note.overdueSales': '{amount} ist von Kunden überfällig und sollte nachverfolgt werden.',
  'adv.rpt.note.overduePurchases': '{amount} ist an Lieferanten überfällig.',
  'adv.rpt.note.noRisks': 'In den gebuchten Zahlen wurden keine Risiken gefunden.',
  'adv.rpt.note.noActions': 'Derzeit werden keine Maßnahmen empfohlen.',
  'adv.rpt.note.notAProtocol': 'Dies ist eine Entscheidungshilfe und ersetzt kein Vorstandsprotokoll. Beschlüsse fasst der Vorstand.',
  'adv.rpt.empty.noBookkeeping': 'Für {year} sind keine Erträge oder Kosten gebucht. Der Bericht erhält Zahlen, sobald Belege vorhanden sind.',
  'adv.rpt.empty.noEvents': 'Im Zeitraum wurden keine wesentlichen Änderungen erfasst.',
  'adv.rpt.empty.noBudget': 'Für {year} gibt es kein Budget. Lege ein Budget an, um Abweichungen im Bericht zu sehen.',
  'adv.rpt.empty.noLiquidityBasis': 'Keine offenen Kunden- oder Lieferantenposten und keine gebuchten Bewegungen, auf denen der Saldo aufbauen kann.',
  'adv.rpt.empty.noForecast': 'Für die Saldokurve gibt es keine abgestimmte Kassengrundlage.',
  'adv.rpt.empty.noBalance': 'Die Summen- und Saldenliste für {year} ist leer.',
  'adv.rpt.empty.noSales': 'Für {year} sind keine fakturierten Umsätze gebucht.',
  'adv.rpt.empty.noCustomerHistory': 'Zu wenig Kundenhistorie, um Wiederkäufe und Zahlungsdauer zu messen.',
  'adv.rpt.empty.noCosts': 'Für {year} sind keine Kosten gebucht.',
  'adv.rpt.empty.noSupplierSplit': 'Die Kosten sind in der Grundlage nicht nach Lieferanten aufgeteilt.',
  'adv.rpt.empty.noReceivables': 'Keine offenen Kundenposten.',
  'adv.rpt.empty.noPayables': 'Keine offenen Lieferantenposten.',
  'adv.rpt.empty.noDecisions': 'Derzeit erfordern keine Punkte eine Entscheidung.',
  'adv.rpt.source.result': 'Gewinn- und Verlustrechnung',
  'adv.rpt.source.balance': 'Summen- und Saldenliste',
  'adv.rpt.source.openItems': 'Offene Kunden- und Lieferantenposten',
  'adv.rpt.source.budget': 'Budget',
  'adv.rpt.source.bank': 'Bankbewegungen',
  'adv.rpt.source.invoices': 'Ausgangsrechnungen',
  'adv.rpt.source.purchases': 'Lieferantenrechnungen',
  'adv.rpt.source.vouchers': 'Belege',
  'adv.rpt.basis.generated': 'Erstellt am {date}.',
  'adv.rpt.basis.period': 'Der Zeitraum umfasst {months} Monate des Jahres {year}.',
  'adv.rpt.basis.noPreviousYear': 'Keine gebuchten Zahlen für {year} — der Vergleich zum Vorjahr fehlt.',
  'adv.rpt.basis.noBudget': 'Keine Budgetzeilen für {year}.',
  'adv.rpt.basis.noPartySplit': 'Die Aufteilung nach Kunden und Lieferanten ist unvollständig. Die Kundenübersicht zeigt, was sich fakturierten Umsätzen zuordnen lässt.',
  'adv.rpt.basis.topFive': 'Kunden- und Lieferantenlisten zeigen die fünf größten.',
  'adv.rpt.basis.bookedOnly': 'Buchhaltungszahlen stammen aus der Buchführung. Der Puffer ist ein Zielwert, kein gebuchter Saldo. Geplante Zahlungen und berechnete Kennzahlen sind im Bericht gekennzeichnet.',
  'adv.rpt.period.monthShort': '{month}/{year}',
  'adv.rpt.period.vsPreviousMonth': 'gegenüber dem Vormonat',
  'adv.rpt.monthPicker.title': 'Monat für den Monatsbericht wählen',
  'adv.rpt.monthPicker.intro': 'Wähle einen der letzten 24 Kalendermonate. Der Bericht verwendet nur gebuchte Zahlen, Budget und Vergleiche für den gewählten Monat.',
  'adv.rpt.monthPicker.separate': 'Der Monatsbericht hat eine eigene Monatsauswahl und wird nicht von der Jahres- oder Quartalsauswahl anderer Berichte beeinflusst.',
  'adv.rpt.monthPicker.continue': 'Monat wählen',
  'adv.rpt.monthPicker.back': 'Zurück zu den Berichtsvorlagen',
  'adv.rpt.monthPicker.generate': 'Monatsbericht erstellen',
  'adv.rpt.sec.monthlyStatus': 'Status des Monats',
  'adv.rpt.sec.monthlyBudget': 'Monat im Vergleich zum Budget',
  'adv.rpt.sec.monthlyComparison': 'Gleicher Monat im Vorjahr',
  'adv.rpt.sec.monthlyTrend': 'Entwicklung der letzten 12 Monate',
  'adv.rpt.sec.monthlyInsights': 'Einschätzung des Monats und nächste Schritte',
  'adv.rpt.empty.noMonthlyBudget': 'Für den gewählten Monat gibt es kein Budget.',
  'adv.rpt.empty.noMonthlyComparison': 'Für denselben Monat im Vorjahr gibt es keine gebuchten Zahlen.',
  'adv.rpt.empty.noMonthlyTrend': 'Im Zwölfmonatsfenster gibt es keine gebuchten Monatszahlen.',
  'adv.rpt.col.budget': 'Budget',
  'adv.rpt.col.variancePct': 'Abweichung in %',
  'adv.rpt.row.result': 'Ergebnis',
  'adv.rpt.chart.monthBudgetActual': 'Budget und Ist für den Monat',
  'adv.rpt.chart.sameMonthComparison': 'Gewählter Monat im Vergleich zum gleichen Monat im Vorjahr',
  'adv.rpt.metric.averageMonthlyResult': 'Durchschnittliches Monatsergebnis',
  'adv.rpt.metric.bestMonthlyResult': 'Bester Monat',
  'adv.rpt.metric.weakestMonthlyResult': 'Schwächster Monat',
  'adv.rpt.monthly.statusProfit': 'Der Monat endete mit einem Gewinn von {result} und einer Ergebnismarge von {margin} %.',
  'adv.rpt.monthly.statusLoss': 'Der Monat endete mit einem Verlust von {result} und einer Ergebnismarge von {margin} %.',
  'adv.rpt.monthly.budgetAbove': 'Das Ergebnis ist {amount} besser als das Budget für den Monat.',
  'adv.rpt.monthly.budgetBelow': 'Das Ergebnis ist {amount} schwächer als das Budget für den Monat.',
  'adv.rpt.monthly.marginChange': 'Die Ergebnismarge hat sich gegenüber dem gleichen Monat im Vorjahr um {change} Prozentpunkte verändert.',
  'adv.rpt.monthly.trendBasis': 'Die Entwicklung zeigt bis zu 12 gebuchte Kalendermonate bis einschließlich des gewählten Monats.',
  'adv.rpt.monthly.insightLossTitle': 'Negatives Monatsergebnis',
  'adv.rpt.monthly.insightLossBody': 'Die Kosten lagen im gewählten Monat um {amount} über den Erlösen.',
  'adv.rpt.monthly.insightProfitTitle': 'Positives Monatsergebnis',
  'adv.rpt.monthly.insightProfitBody': 'Der Monat brachte einen Gewinn von {amount}. Prüfe, welche Erlöse und Kosten sich wiederholen sollten.',
  'adv.rpt.monthly.insightIncomeDownTitle': 'Niedrigere Erlöse als im Vorjahr',
  'adv.rpt.monthly.insightIncomeDownBody': 'Die Erlöse liegen {change} % unter dem gleichen Monat im Vorjahr.',
  'adv.rpt.monthly.insightCostsTitle': 'Kosten über Budget',
  'adv.rpt.monthly.insightCostsBody': 'Die Kosten liegen {amount} über dem Budget für den Monat.',
  'adv.rpt.monthly.insightBudgetTitle': 'Ergebnis unter Budget',
  'adv.rpt.monthly.insightBudgetBody': 'Das Ergebnis ist {amount} schwächer als das Budget für den Monat.',
  'adv.rpt.monthly.stepReviewDrivers': 'Geh die Posten durch, die das Monatsergebnis erklären, und kläre, was dauerhaft ist.',
  'adv.rpt.monthly.stepRevenue': 'Verfolge den Erlösrückgang gegenüber dem gleichen Monat im Vorjahr.',
  'adv.rpt.monthly.stepCosts': 'Identifiziere die Kosten, die über dem Monatsbudget liegen.',
  'adv.rpt.monthly.stepBudget': 'Aktualisiere die Maßnahmen, um die Ergebnisabweichung zum Monatsbudget zu schließen.',
  'adv.rpt.monthly.stepContinue': 'Erhalte die Treiber hinter dem positiven Monatsergebnis und beobachte die Entwicklung im nächsten Monat.',
});
